import clientRequest from '@/utils/clientRequest';

const PATH = '/nice';

export const getEncData = () => clientRequest({
  url: PATH,
  method: 'get',
});

export const getInfo = (encodeData: any) => clientRequest({
  url: `${PATH}/info`,
  method: 'get',
  params: {
    encData: encodeData,
  },
});
